import { Route, Routes } from 'react-router-dom';
import EntityFormList from './EntityForm/List.tsx';
import CreateEntityForm from './EntityForm/CreateEntityForm.tsx';
import EntityDetail from './EntityData/EntityDetail.tsx';
import { ConstantActions } from '../../Services/_actions/constant.actions.js';
import { globalpermissions } from '../../Services/Permission.js';
import CreateEditFormData from './EntityData/CreateEditFormData.tsx';


const DatasetsRoutes = () => {
    const actions = ConstantActions();

    return (
        <Routes>
            {actions.userHasPermission([globalpermissions?.pagePermissions?.selfServiceFormsAccess]) &&
                <>
                    <Route path={'/'} element={<EntityFormList />} />
                    <Route path={'/form-create/*'} element={<CreateEntityForm />} />
                </>
            }
            {actions.userHasPermission([globalpermissions?.pagePermissions?.selfServiceDataAccess]) &&
                <>
                    <Route path={'/data-details/:entityFormId'} element={<EntityDetail />} />
                    <Route path={'/data/:uuid/:entityFormId'} element={<CreateEditFormData />} />
                </>
            }
        </Routes>
    );
};

export default DatasetsRoutes;